import { GlobeFillIcon, ICON_COLOR, LockFillIcon } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
export interface PublicBadgeProps {
  /** 공개 여부 */
  isPublic: boolean;
}

/**
 * PublicBadge - 퀴즈 공개 여부 배지
 *
 * @description
 * 퀴즈의 공개/비공개 상태를 아이콘과 텍스트로 표시합니다.
 * - 공개: 지구본 아이콘 + "공개"
 * - 비공개: 자물쇠 아이콘 + "비공개"
 */
export const PublicBadge = ({
  isPublic
}: PublicBadgeProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex shrink-0 items-center gap-2xs" data-sentry-component="PublicBadge" data-sentry-source-file="PublicBadge.tsx">
      <div className="flex size-[16px] items-center justify-center">
        {isPublic ? <GlobeFillIcon size="2xs" fill={ICON_COLOR.neutral} /> : <LockFillIcon size="2xs" fill={ICON_COLOR.neutral} />}
      </div>
      <p className="text-caption-lg-semibold text-neutral">
        {isPublic ? t('detail.publicQuiz') : t('detail.privateQuiz')}
      </p>
    </div>;
};